module.exports = __webpack_public_path__ + "static/media/01.8ecc104f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionTwo/expos/01.png
// module id = 172
// module chunks = 0